import { render, staticRenderFns } from "./GridTiposProjecaoVendas.vue?vue&type=template&id=091a11a3"
import script from "./GridTiposProjecaoVendas.vue?vue&type=script&setup=true&lang=js"
export * from "./GridTiposProjecaoVendas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports